/**
 * A chave carrega o perfil: o resultado é por conta, e sem ele sair de um QG e
 * entrar numa conta comum serviria a barra do QG do cache (docs/04 §2).
 */
export const institutionRolesKeys = {
  all: ['institution-roles'] as const,
  mine: (profileId: string) => [...institutionRolesKeys.all, 'mine', profileId] as const,
};
